module.exports = __webpack_public_path__ + "media/images/user_0_default_avatar-4f5e67b031a70e3377fd8b9fccbf916a.png";